import template from './index-mappings-tab-content.template.html';
import controller from './index-mappings-tab-content.controller';

const indexMappingsTabContentComponent = {
  bindings: {
    mappings: '<'
  },
  template,
  controller,
  controllerAs: 'iMTContentCtrl'
};

export default indexMappingsTabContentComponent;



// WEBPACK FOOTER //
// ./ui/src/components/index-mappings-tab-content/index-mappings-tab-content.component.js